import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DataService } from '../../../app/service/data.service';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { Subject } from 'rxjs/internal/Subject';
import { combineLatest, debounceTime, forkJoin, from, Subscription } from 'rxjs';
import { WorkingScheduleService } from './working-schedule.service';
import { AuthDetailsService } from '../auth-details/auth-details.service';

@Component({
    selector: 'app-working-schedule',
    templateUrl: './working-schedule.component.html'
})

export class WorkingScheduleComponent implements OnInit, OnDestroy {

    @Input() onPartyChanged: Subject<string> = new Subject<string>()
    @Input() partyId: string = null;
    @Input() userId?: string = null;
    workingScheduleSub: Subscription
    schedulerComponent: any;

    constructor(public ds: DataService, private ad: AuthDetailsService, private entity: iBisEntityService, private workingSchedule: WorkingScheduleService) { }

    ngOnInit() {
        /*    this.ad.partyUserDataLoadedSubject.subscribe(_ => {
               this.workingSchedule.partyId = this.ad.authDetails.party.id;
               console.log(this.workingSchedule.pId)
           })
           this.onPartyChanged.pipe(debounceTime(500)).subscribe((change: string) => {
               if (change === 'party-selected') {
                   this.workingSchedule.partyId = this.partyId;
               }
           }) */
        this.workingScheduleSub = combineLatest([this.ad.partyUserDataLoadedSubject, this.onPartyChanged]).subscribe(([partyDataLoaded, partyChange]) => {
            this.workingSchedule.partyId = this.partyId || this.ad.authDetails.party.id;
            this.workingSchedule.getWorkingDays(this.workingSchedule.pId, this.userId).then((schedule: any) => {
                this.schedulerComponent.option('dataSource', this.createSchedule(schedule))
            });
        });
    }

    ngOnDestroy() {
        if (this.workingScheduleSub) {
            this.workingScheduleSub.unsubscribe();
        }
    }

    onScheduleInit(ev: any) {
        this.schedulerComponent = ev.component;
    }

    createSchedule(schedule: any) {
        const obj = {};
        for (let i = 0; i < 7; i++) {
            const fromHourKey = 'startTime' + i;
            const toHourKey = 'endTime' + i;
            const tdy = new Date();
            const dayExists = schedule.find((x: any) => x.weekDay === i);
            const startTimeHours = dayExists && dayExists.startTime ? Number(dayExists.startTime.split(':')[0]) : 0;
            const startTimeMinutes = dayExists && dayExists.startTime ? Number(dayExists.startTime.split(':')[1]) : 0;
            const startTimeValue = new Date(tdy.getFullYear(), tdy.getMonth() + 1, tdy.getDate(), startTimeHours, startTimeMinutes, 0);
            obj[fromHourKey] = startTimeValue;

            const endTimeHours = dayExists && dayExists.endTime ? Number(dayExists.endTime.split(':')[0]) : 0;
            const endTimeMinutes = dayExists && dayExists.endTime ? Number(dayExists.endTime.split(':')[1]) : 0;
            const endTimeValue = new Date(tdy.getFullYear(), tdy.getMonth() + 1, tdy.getDate(), endTimeHours, endTimeMinutes, 0);
            obj[toHourKey] = endTimeValue;
        }
        return [obj];
    }

    onRowUpdating(ev: any) {
        const key = Object.keys(ev.newData)[0],
            date: any = Object.values(ev.newData)[0],
            day = Number(key.substr(key.length - 1)),
            keyToUpdate = key.substr(0, key.length - 1);
        const obj = { weekDay: day, partyId: this.workingSchedule.pId, userId: this.userId };
        const value = this.workingSchedule.returnTime(date);
        obj[keyToUpdate] = value;
        const q = new EntityQuery('WorkingSchedule').eq('partyId', this.workingSchedule.pId).eq('weekDay', day);
        if (this.userId) {
            q.eq('userId', this.userId);
        }
        this.entity.single(q).then((result: any) => {
            this.workingSchedule.addEditWorkingSchedule(obj, result);
        });
    }

    onDoctorRowValidating(ev: any) {
        if (this.userId) {
            const key = Object.keys(ev.newData)[0],
                date: any = Object.values(ev.newData)[0],
                day = Number(key.substr(key.length - 1)),
                keyToUpdate = key.substr(0, key.length - 1);
            const obj = { weekDay: day, partyId: this.workingSchedule.pId };
            const value = this.workingSchedule.returnTime(date);

            obj[keyToUpdate] = value;
            ev.promise = this.ds.getClinicWorkingSchedule(this.workingSchedule.pId, day).then((wDay: any) => {
                if (wDay && wDay[keyToUpdate]) {
                    ev.errorText = 'Ora se afla in afara programului clinicii (' + wDay.startTime + ' - ' + wDay.endTime + ')';
                    if (keyToUpdate === 'startTime') {
                        ev.isValid = wDay[keyToUpdate] <= obj[keyToUpdate];
                    } else if (keyToUpdate === 'endTime') {
                        ev.isValid = wDay[keyToUpdate] >= obj[keyToUpdate];
                    }
                } else {
                    ev.isValid = true;
                }

            });
        }
    }
}